// initial state
const state = {
	profile: {},
	sessionUser: {},
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setProfile(state, profile) {
    state.profile = profile;
	},
	setSessionUser(state, user) {
		state.sessionUser = user;
	},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}